import type { AINumber } from '@app/services/api.types';
import { Descriptions, Drawer, Flex, type DescriptionsProps, type DrawerProps } from 'antd';

export type NumberDrawerProps = DrawerProps & {
    data: AINumber | null;
};

export const NumberDrawer = ({ data, ...props }: NumberDrawerProps) => {
    const detailsItems: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'Agent Number',
            children: data?.number || '-',
            span: 2,
        },
        {
            key: '2',
            label: 'Agent Name',
            children: data?.agent_name || '-',
        },
        {
            key: '3',
            label: 'Agent Type',
            children: data?.agent_type || '-',
        },
        {
            key: '4',
            label: 'Location',
            children:
                data?.brand && data?.location
                    ? `${data.brand}  ${data.location}`
                    : data?.location || data?.brand || '-',
        },
        {
            key: '5',
            label: 'Failover Number',
            children: data?.failover_number || '-',
        },
    ];

    const renderDetailsTab = () => {
        return (
            <Descriptions
                title="Details"
                colon={false}
                layout="vertical"
                items={detailsItems}
                column={2}
            />
        );
    };

    return (
        <Drawer
            title={
                <>
                    <Flex align="center" justify="space-between" gap={12}>
                        <span>AI Number Details</span>
                    </Flex>
                    {data?.id ? (
                        <div className="ant-drawer-header-meta">
                            <span>ID: {data?.id}</span>
                        </div>
                    ) : null}
                </>
            }
            size={700}
            closable={{ 'aria-label': 'Close Button' }}
            {...props}>
            {renderDetailsTab()}
        </Drawer>
    );
};

export default NumberDrawer;
